import './formDetalle.scss';
import { useState, useEffect, useContext } from "react";
import { ListasDetFormContext } from '../../../../../context/listasdet/ListasDetContext';
import ArticulosModal from '../../../../articulos/articulosModal/articulosModal'; 
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";

export const FormDetalle = ({
  lpid,
  iddet,
  tipolista,
  tipoprecio,
  addItem,
  getItem,
  updateItem,
  arrayDetalle,
  closeModal
}) => {

  const {
    report,
    getListaDetByIdData,
    patchListaDetData,
    getArticuloByIdData,
  } = useContext(ListasDetFormContext);

  const [title, setTitle] = useState('');
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [selectedRow, setSelectedRow] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [estadoForm, setEstadoForm] = useState('');

  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    iddet ? setTitle('Editar Artículo de Lista') : setTitle('Agregar Artículo a Lista');
  }, [iddet]);

  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.art_id === iddet);

        if (detalleEnArray) {
          const art = detalleEnArray.lista_articulos || {};
          const costo = Number(art.art_npreciocosto) || 0;
          
          // Precio base según tipoprecio
          const precioBase = Number(tipoprecio) === 0 ? Number(art.art_npreciomayorista) :
                             Number(tipoprecio) === 1 ? Number(art.art_nprecioventa) :
                             costo;
          
          // Precio de lista (el que tiene la lista aplicada)
          const precioLista = Number(detalleEnArray.alp_art_nprecioventa) || 
                              Number(detalleEnArray.alp_art_npreciomayorista) || 
                              precioBase;

          // Margen Actual: costo vs precio base del artículo
          const margenActual = costo > 0 ? ((precioBase - costo) / costo) * 100 : 0;
          
          // Margen Lista: costo vs precio final de lista
          const margenLista = costo > 0 ? ((precioLista - costo) / costo) * 100 : 0;

          setForm((prevForm) => ({
            ...prevForm,
            ...detalleEnArray,
            art_descripcion: detalleEnArray?.lista_Art?.art_descripcion || art.art_descripcion || "",
            art_codigo: art.art_codigo || "",
            art_npreciocosto: costo.toFixed(2),
            alp_art_npreciobase: precioBase.toFixed(2),
            alp_margen_actual: margenActual.toFixed(2),
            alp_margen: margenLista.toFixed(2),
          }));
          setEstadoForm(1);
          
        } else {
          try {
            const detalle = await getListaDetByIdData(iddet, lpid);
            if (detalle) {
              const articulo = await getArticuloByIdData(detalle.art_id);
              const art = detalle.lista_articulos || {};
              
              const costo = Number(art.art_npreciocosto) || 0;
              const tipoPrec = detalle.ListaP?.lp_tipo_precio;
              
              // Precio base según tipo de lista
              const precioBase = tipoPrec === 0 ? Number(art.art_npreciomayorista) : 
                                 tipoPrec === 1 ? Number(art.art_nprecioventa) :
                                 costo;
              
              // Precio de lista
              const precioLista = tipoPrec === 0 ? Number(detalle.alp_art_npreciomayorista) : 
                                  tipoPrec === 1 ? Number(detalle.alp_art_nprecioventa) : 
                                  Number(detalle.alp_art_npreciocosto);

              // Márgenes
              const margenActual = costo > 0 ? ((precioBase - costo) / costo) * 100 : 0;
              const margenLista = costo > 0 ? ((precioLista - costo) / costo) * 100 : 0;

              setForm(prevForm => ({
                ...prevForm,
                ...detalle,
                art_descripcion: articulo?.art_descripcion ?? '',
                art_codigo: articulo?.art_codigo ?? '',
                art_npreciocosto: costo.toFixed(2),
                alp_art_npreciobase: precioBase.toFixed(2),
                alp_margen_actual: margenActual.toFixed(2),
                alp_margen: margenLista.toFixed(2),
              }));
              setEstadoForm(1);
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
    };

    fetchData();
  }, [lpid, iddet, tipoprecio]);

  const handleSelectArticulo = (art_id, art_codigo, art_descripcion, art_npreciocosto, preciobuscado) => {
    const precioBase = Number(preciobuscado);
    const costo = Number(art_npreciocosto);
    const margenActual = costo > 0 ? ((precioBase - costo) / costo) * 100 : 0;

    setForm((prevForm) => ({
      ...prevForm,
      art_id: art_id,
      art_codigo: art_codigo,
      art_descripcion: art_descripcion,
      art_npreciocosto: costo.toFixed(2),
      alp_art_npreciobase: precioBase.toFixed(2),
      alp_margen_actual: margenActual.toFixed(2),
      alp_porclista: 0,
      alp_margen: margenActual.toFixed(2),
      alp_imp_fijo: 0,
      alp_tipo_actualizacion: 0,
      alp_art_nprecioventa: precioBase.toFixed(2),
      alp_art_npreciomayorista: precioBase.toFixed(2),
    }));
  };

 const handleInputChange = (e) => {
  const { name, value } = e.target;

  setForm((prevForm) => {
    let updatedForm = { ...prevForm };
    updatedForm[name] = value;

    const precioBase = Number(updatedForm.alp_art_npreciobase) || 0;
    const costo = Number(updatedForm.art_npreciocosto) || 0;

    // ═══════════════════════════════════════════════════════════════
    // Si cambia % INCREMENTO → calcula PRECIO e IMPORTE FIJO
    // ═══════════════════════════════════════════════════════════════
    if (name === "alp_porclista") {
      const porcentaje = Number(value) || 0;
      const precioFinal = precioBase * (1 + porcentaje / 100);
      const impFijo = precioFinal - precioBase;  // ← Calcula importe fijo
      const margen = costo > 0 ? ((precioFinal - costo) / costo) * 100 : 0;

      updatedForm.alp_imp_fijo = impFijo.toFixed(2);
      updatedForm.alp_art_nprecioventa = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciomayorista = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciocosto= precioFinal.toFixed(2);
      updatedForm.alp_margen = margen.toFixed(2);
    }

    // ═══════════════════════════════════════════════════════════════
    // Si cambia IMPORTE FIJO → calcula PRECIO y %
    // ═══════════════════════════════════════════════════════════════
    if (name === "alp_imp_fijo") {
      const impFijo = Number(value) || 0;
      const precioFinal = precioBase + impFijo;
      const porcentaje = precioBase > 0 ? ((precioFinal - precioBase) / precioBase) * 100 : 0;  // ← Calcula %
      const margen = costo > 0 ? ((precioFinal - costo) / costo) * 100 : 0;

      updatedForm.alp_porclista = porcentaje.toFixed(2);
      updatedForm.alp_art_nprecioventa = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciomayorista = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciocosto= precioFinal.toFixed(2);
      updatedForm.alp_margen = margen.toFixed(2);
    }

    // ═══════════════════════════════════════════════════════════════
    // Si cambia PRECIO → calcula % e IMPORTE FIJO
    // ═══════════════════════════════════════════════════════════════
    if (name === "alp_art_nprecioventa" || name === "alp_art_npreciomayorista") {
      const precioFinal = Number(value) || 0;
      const porcentaje = precioBase > 0 ? ((precioFinal - precioBase) / precioBase) * 100 : 0;
      const impFijo = precioFinal - precioBase;  // ← Calcula importe fijo
      const margen = costo > 0 ? ((precioFinal - costo) / costo) * 100 : 0;

      updatedForm.alp_porclista = porcentaje.toFixed(2);
      updatedForm.alp_imp_fijo = impFijo.toFixed(2);
      updatedForm.alp_margen = margen.toFixed(2);
      updatedForm.alp_art_nprecioventa = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciomayorista = precioFinal.toFixed(2);
      updatedForm.alp_art_npreciocosto= precioFinal.toFixed(2);
    }

    return updatedForm;
  });
};

  const validateForm = async () => {
    let formErrors = {};

    if (!form.art_codigo || form.art_codigo.trim() === '') {
      formErrors.art_codigo = 'El Código es obligatorio';
    }

    if (!form.art_id) {
      formErrors.art_id = 'Debe seleccionar un artículo';
    }

    const precioFinal = Number(form.alp_art_nprecioventa) || Number(form.alp_art_npreciomayorista);
    if (!precioFinal || precioFinal <= 0) {
      formErrors.alp_art_nprecioventa = 'El precio final debe ser mayor a 0';
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    if (!iddet) {
      const existente = await buscarExistente();
      if (existente) {
        formErrors.art_codigo = 'El artículo ya existe en esta lista';
        setErrors(formErrors);
        return false;
      }
    }

    setErrors({});
    return true;
  };

  const buscarExistente = async () => {
    const encontradoArray = arrayDetalle.find(item => item.art_id === form.art_id);

    if (Number(lpid)) {
      const encontradoData = await getListaDetByIdData(form.art_id, lpid); 
      if (encontradoData?.pagination?.totalItems > 0) {
        return encontradoData;
      }
    }

    return encontradoArray || null;
  };

  const handleSendData = async () => {
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }

    setIsSubmitting(true);
    try {
      const generateRandomId = () => `temp-${Math.floor(Math.random() * 1000000)}-${Date.now()}`;

      const lista_Art = {
        id: form.art_id,
        art_descripcion: form.art_descripcion,
        art_codigo: form.art_codigo,
        art_npreciocosto: Number(form.art_npreciocosto) || 0,
      };

      const newForm = {
        art_id: form.art_id,
        lp_id: Number(lpid) || null,
        alp_art_npreciocosto: Number(form.art_npreciocosto) || 0,
        alp_art_nprecioventa: Number(form.alp_art_nprecioventa) || 0,
        alp_art_npreciomayorista: Number(form.alp_art_npreciomayorista) || 0,
        alp_porclista: Number(form.alp_porclista) || 0,
        alp_margen: Number(form.alp_margen) || 0,
        alp_tipo_actualizacion: Number(form.alp_tipo_actualizacion) || 0,
        alp_imp_fijo: Number(form.alp_imp_fijo) || 0,
        alp_show_web: form.alp_show_web ,
        alp_show_app: form.alp_show_app ,
        lista_Art: lista_Art,
        id: iddet || generateRandomId(),
      }; 
      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.art_id === iddet);
        if (detalleEnArray) { 
          await updateItem(detalleEnArray.id, newForm);
        } else { 
          await patchListaDetData(form.art_id, lpid, newForm);
        }
      } else { 
        await addItem(newForm);
      }

      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
      openErrorDialog("Error al guardar. Intente nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const resetForm = () => {
    setForm({});
  };

  const handleCancel = () => {
    setSelectedRow('');
    setEstadoForm(0);
    resetForm();
    closeModal();
  };

  const getPrecioLabel = () => {
    if (Number(tipoprecio) === 0) return "Precio Mayorista";
    if (Number(tipoprecio) === 1) return "Precio Minorista";
    return "Precio Lista";
  };

  const getPrecioField = () => {
    if (Number(tipoprecio) === 0) return "alp_art_npreciomayorista";
    if (Number(tipoprecio) === 1) return "alp_art_nprecioventa";
    return "alp_art_npreciocosto";
  };

  return (
    <>
      <div className="formDetalle">
        <div className="formDetalle__header">
          <h3>{title}</h3>
        </div>

        <div className="formDetalle__body">
          {/* SECCIÓN: ARTÍCULO */}
          <div className="formDetalle__section">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">📦</span>
              Artículo
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--3cols">
              
              {estadoForm !== 1 && (
                <div className="formDetalle__field formDetalle__field--search">
                  <label>Buscar Artículo</label>
                  <ArticulosModal
                    handleChange={setSearchIdArt}
                    handleDescChange={setSearchDescArt}
                    descSelected={searchIdArt}
                    onSelect={handleSelectArticulo}
                    tipoprecio={tipoprecio}
                  />
                </div>
              )}

              <div className="formDetalle__field">
                <label>Código</label>
                <input
                  type="text"
                  value={form.art_codigo ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
                {errors.art_codigo && <span className="formDetalle__error">{errors.art_codigo}</span>}
              </div>

              <div className="formDetalle__field formDetalle__field--wide">
                <label>Descripción</label>
                <input
                  type="text"
                  value={form.art_descripcion ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* SECCIÓN: PRECIOS ACTUALES */}
          <div className="formDetalle__section formDetalle__section--info">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">💰</span>
              Precios Actuales
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--3cols">
              
              <div className="formDetalle__field">
                <label>Costo</label>
                <input
                  type="number"
                  value={form.art_npreciocosto ?? ''}
                  className="formDetalle__input formDetalle__input--readonly formDetalle__input--costo"
                  readOnly
                />
              </div>

              <div className="formDetalle__field">
                <label>Precio Base</label>
                <input
                  type="number"
                  value={form.alp_art_npreciobase ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
              </div>

              <div className="formDetalle__field">
                <label>Margen Actual</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    value={form.alp_margen_actual ?? ''}
                    className="formDetalle__input formDetalle__input--readonly formDetalle__input--margen"
                    readOnly
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN: CONFIGURACIÓN DE LISTA */}
          <div className="formDetalle__section formDetalle__section--edit">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">⚙️</span>
              Configuración de Lista
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--4cols">
              
              <div className="formDetalle__field">
                <label>% Incremento</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    name="alp_porclista"
                    value={form.alp_porclista ?? ''}
                    className="formDetalle__input"
                    onChange={handleInputChange}
                    step="0.01"
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
              </div>

              <div className="formDetalle__field">
                <label>Importe Fijo</label>
                <div className="formDetalle__input-group">
                  <span className="formDetalle__input-prefix">$</span>
                  <input
                    type="number"
                    name="alp_imp_fijo"
                    value={form.alp_imp_fijo ?? ''}
                    className="formDetalle__input"
                    onChange={handleInputChange}
                    step="0.01"
                  />
                </div>
              </div>

              <div className="formDetalle__field formDetalle__field--highlight">
                <label>{getPrecioLabel()}</label>
                <div className="formDetalle__input-group">
                  <span className="formDetalle__input-prefix">$</span>
                  <input
                    type="number"
                    name={getPrecioField()}
                    value={form[getPrecioField()] ?? ''}
                    className="formDetalle__input formDetalle__input--precio"
                    onChange={handleInputChange}
                    step="0.01"
                  />
                </div>
                {errors.alp_art_nprecioventa && <span className="formDetalle__error">{errors.alp_art_nprecioventa}</span>}
              </div>

              <div className="formDetalle__field">
                <label>Margen Lista</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    value={form.alp_margen ?? ''}
                    className={`formDetalle__input formDetalle__input--readonly ${
                      Number(form.alp_margen) >= 0 ? 'formDetalle__input--positive' : 'formDetalle__input--negative'
                    }`}
                    readOnly
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN: OPCIONES */}
          <div className="formDetalle__section formDetalle__section--options">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">🔧</span>
              Opciones
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--row">
              
              <div className="formDetalle__field">
                <label>Tipo Actualización</label>
                <select
                  name="alp_tipo_actualizacion"
                  value={form.alp_tipo_actualizacion || 0}
                  className="formDetalle__select"
                  onChange={handleInputChange}
                >
                  <option value={0}>Manual</option>
                  <option value={1}>Automático por %</option>
                  <option value={2}>Automático por Importe</option>
                </select>
              </div>

              <div className="formDetalle__checkboxes">
                <label className="formDetalle__checkbox">
                  <input
                    type="checkbox"
                    checked={form.alp_show_web === 0}
                    onChange={(e) => setForm({ ...form, alp_show_web: e.target.checked ? 0 : 1 })}
                  />
                  <span className="formDetalle__checkbox-label">🌐 Mostrar en Web</span>
                </label>
                <label className="formDetalle__checkbox">
                  <input
                    type="checkbox"
                    checked={form.alp_show_app === 0}
                    onChange={(e) => setForm({ ...form, alp_show_app: e.target.checked ? 0 : 1 })}
                  />
                  <span className="formDetalle__checkbox-label">📱 Mostrar en App</span>
                </label>
              </div>
            </div>
          </div>

          {/* BOTONES */}
          <div className="formDetalle__actions">
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--primary"
              onClick={handleSendData}
              disabled={isSubmitting}
            >
              {isSubmitting ? '⏳ Guardando...' : '✓ Guardar'}
            </button>
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--secondary"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              ✕ Cancelar
            </button>
          </div>
        </div>
      </div>

      <ErrorDialog
        isOpen={isErrorDialogOpen}
        onClose={closeErrorDialog}
        message={errorMessage}
        title=""
      />
    </>
  );
};

export default FormDetalle;